import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {SupplierInvoiceReportData} from "./supplier-invoice-report.data";

@Injectable()
export class SupplierInvoiceReportModel extends ReportModel<SupplierInvoiceReportData> {
    constructor(injector: Injector) {
        super(injector, SupplierInvoiceReportData)
    }
}
